import React from "react";
import { Divider } from "antd";
import PropTypes from "prop-types";
import Highlight from "react-highlighter";
import { Link } from "react-router-dom";
import * as router from "@/constants/routes";
import CoreTable from "@mds/common/components/common/CoreTable";
import {
  renderHighlightedTextColumn
} from "@mds/common/components/common/CoreTableCommonColumns";
import { useFeatureFlag } from "@mds/common/providers/featureFlags/useFeatureFlag";
import { Feature } from "@mds/common/utils/featureFlag";

/**
 * @class  PermitResultsTable - displays a table of mine search results
 */

const propTypes = {
  header: PropTypes.string.isRequired,
  highlightRegex: PropTypes.objectOf(PropTypes.regexp).isRequired,
  searchResults: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const defaultProps = {};

export const PermitResultsTable = (props) => {
  const { isFeatureEnabled } = useFeatureFlag();

  const columns = [
    {
      title: "Permit No.",
      key: "permit_no",
      render: (record) => {
        const hasMine = record.mine && record.mine.length > 0 && record.mine[0]?.mine_guid;
        if (isFeatureEnabled(Feature.DIGITIZED_PERMITS) && hasMine) {
          return (
            <Link
              to={router.VIEW_MINE_PERMIT.dynamicRoute(
                record.mine[0].mine_guid,
                record.permit_guid
              )}
            >
              <Highlight search={props.highlightRegex}>{record.permit_no}</Highlight>
            </Link>
          );
        } else {
          return <Highlight search={props.highlightRegex}>{record.permit_no}</Highlight>;
        }
      },
    },
    renderHighlightedTextColumn("current_permittee", "Permittee", props.highlightRegex),
    {
      title: "Mine(s)",
      key: "mine_guid",
      render: (record) => {
        if (!record.mine || record.mine.length === 0) {
          return "-";
        }
        return record.mine.map((mine, index) => (
          <React.Fragment key={"mine-link-" + mine.mine_guid}>
            {index > 0 && ", "}
            <Link to={router.MINE_PERMITS.dynamicRoute(mine.mine_guid)}>
              <Highlight search={props.highlightRegex}>{mine.mine_name || mine.mine_guid}</Highlight>
            </Link>
          </React.Fragment>
        ));
      },
    },
  ];

  return (
    <div className="padding-lg--bottom">
      <h2>{props.header}</h2>
      <Divider />
      <CoreTable columns={columns} dataSource={props.searchResults} />
    </div>
  );
};

PermitResultsTable.propTypes = propTypes;
PermitResultsTable.defaultProps = defaultProps;

export default PermitResultsTable;
